import { useForm } from '@/common/form/FormContext';
import { DateFormField } from '@/common/form/formFields/DateFormField';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { DateUtils } from '@/common/utils/DateUtils';
import { useEffect, useState } from 'react';

export const Ndc11ProdFirstSaleDate = ({ fieldDef }) => {

  // Retrieve the NDC9 entity, for attributes necessary for validation
  const [marketEntryDate, setMarketEntryDate] = useState(null);
  const rsrc = useRsrc();
  const { formValues } = useForm();


  // Retrieve NDC9 for Market Entry Date
  useEffect(() => {
    if (!formValues.ndc9ProdId) return;
    rsrc.byId('md', 'NDC9_PROD', formValues.ndc9ProdId).then((res) => {
      setMarketEntryDate(res.marketEntryDate);
    });
  }, [formValues.ndc9ProdId]);


  // Validate first sales date based on market entry date
  const firstSaleDateValidator = (value, formValues) =>
    value && value < marketEntryDate ?
      'First sale date must come after the Market Entry Date (' + DateUtils.format(marketEntryDate) + ')'
      : null;

  fieldDef.validators = [firstSaleDateValidator];

  return (
    <DateFormField fieldDef={fieldDef} ></DateFormField>
  )
}